import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { RDReadyNav } from './RDReadyNav';
import { RDReadyFooter } from './RDReadyFooter';
export function RDReadyLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen flex-col bg-white font-sans text-[#1E293B]" data-id="element-3878" data-mp="bzy2ilvmadaj">
      <RDReadyNav data-id="element-3879" data-mp="3ue70ebz6bjnw" />
      <main className="flex-1" data-id="element-3880" data-mp="3udp81qfmtpl9">
        <Outlet data-id="element-3881" data-mp="3udfha0mrjeei" />
      </main>
      <RDReadyFooter data-id="element-3882" data-mp="302nu72us05r" />
    </div>;
}